<template>
    <span>
        <span class="fa fa-star" v-for="i in wholeStars"></span><span class="fa fa-star-half-o" v-if="halfStar"></span><span class="fa fa-star-o" v-for="i in emptyStars"></span>
    </span>
</template>

<script>
    export default {
        props: ['stars'],
        computed: {
            effectiveStars() {
                return Math.round(this.stars * 2) / 2;
            },
            wholeStars() {
                return Math.floor(this.effectiveStars);
            },
            halfStar() {
                return (this.effectiveStars != this.wholeStars);
            },
            emptyStars() {
                var value = 5 - this.wholeStars;
                if (this.halfStar)
                    value--;
                return value;
            },
        }
    }
</script>
